import BaseApi from './base'

class FirmwareVersionPers extends BaseApi {
  getListFirmwareVersionPers = (query) =>
    this.client.get(`pers-firmware-versions?${query}`)

  getDetailFirmwareVersionPers = (id) =>
    this.client.get(`pers-firmware-versions/${id}`)

  addFirmwareVersionPers = (data) =>
    this.client.post('pers-firmware-versions', data)

  updateFirmwareVersionPers = ({ firmwareVersionId, payload }) =>
    this.client.patch(`pers-firmware-versions/${firmwareVersionId}`, payload)

  deleteFirmwareVersionPers = (id) =>
    this.client.delete(`pers-firmware-versions/${id}`)

  regenerateUuidFirmwareVersionPers = (id) =>
    this.client.post(`pers-firmware-versions/${id}/regenerate-uuid`)

  regenerateSegmentsFirmwareVersionPers = (id) =>
    this.client.post(`pers-firmware-versions/${id}/regenerate-segments`)

  getSystemFirmwareVersionPers = (query) =>
    this.client.get(`pers-firmware-versions/filters?${query}`)

  downloadFirmwareVersionPers = (id) =>
    this.client.get(`pers-firmware-versions/${id}/download`)
}

export default new FirmwareVersionPers()
